// extracted by mini-css-extract-plugin
module.exports = {"SectionA3":"SectionCold_SectionA3__xsb_u"};